import React, { useContext } from 'react';
import { Button, createStyles, makeStyles, Theme } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { LOGIN_PAGE, REGISTER_PAGE } from '../../constants';
import { RouteContext } from '../../context';
import { AUTH_STATES } from '../../constants/authConsts';
import { openAuthModal } from '../../store/ui/actions';
import history from '../../history';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    authButton: {
      marginLeft: theme.spacing(1),
      color: theme.palette.primary.contrastText,
      padding: '4px',
    },
    registerButton: {
      marginLeft: theme.spacing(1),
      color: theme.palette.primary.contrastText,
      padding: '4px',
      border: '1px solid #ddd',
    },
  }),
);

const UnAuthNavbarActions = () => {
  const classes = useStyles();
  const { isMobile } = useContext(RouteContext);
  const dispatch = useDispatch();

  const navigate = (path: string) => {
    if (isMobile && (path === REGISTER_PAGE || path === LOGIN_PAGE)) {
      dispatch(openAuthModal(AUTH_STATES.DESKTOP_ONLY_MODAL));
      return;
    }
    history.push(path);
  };

  return (
    <>
      <Button
        id="navbar-signIn"
        onClick={() => navigate(LOGIN_PAGE)}
        className={classes.authButton}
      >
        Log In
      </Button>
      <Button
        id="navbar-signUp"
        onClick={() => navigate(REGISTER_PAGE)}
        className={classes.registerButton}
      >
        Sign Up
      </Button>
    </>
  );
};

export default UnAuthNavbarActions;
